/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiAwLjI5OTk4OEwxLjUzOTk5IDEwLjc1TDAuMjk5OTg4IDE1LjdMNS4yMzk5OSAxNC40NkwxNS43IDMuOTk5OTlMMTIgMC4yOTk5ODhaTTE0LjI4IDMuOTk5OTlMMTMgNS4yOTk5OUwxMC43IDIuOTk5OTlMMTIgMS43MTk5OUwxNC4yOCAzLjk5OTk5Wk00Ljk5OTk5IDEzLjNMMi42OTk5OSAxMUw5Ljk5OTk5IDMuNzE5OTlMMTIuMjggNS45OTk5OUw0Ljk5OTk5IDEzLjNaTTIuMjU5OTkgMTJMMy45OTk5OSAxMy43NEwxLjY2OTk5IDE0LjMyTDIuMjU5OTkgMTJaIiBmaWxsPSJpbmhlcml0Ii8+";